import { render, staticRenderFns } from "./Jobcard.vue?vue&type=template&id=18f4ed2b&scoped=true&"
import script from "./Jobcard.vue?vue&type=script&lang=js&"
export * from "./Jobcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f4ed2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
